// src/components/ProtectedRoute.jsx (for Public Portal)
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
// Make sure the path to AuthContext is correct FOR THE PUBLIC PORTAL
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        // Optional: Show a loading indicator while auth check is happening
        return <div>Loading Session...</div>;
    }

    if (!isAuthenticated) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to in case we want to send them back after login.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If authenticated, render the child route element
    return <Outlet />;
};

export default ProtectedRoute;